import { AppThunk, AppDispatch } from '@app/store/store'

import { actions } from './slice'
import { LeadSourceInfo } from './types'

export const getUser = (): AppThunk => async (dispatch: AppDispatch) => {
  try {
    dispatch(actions.successFetchUser())
  } catch {
    dispatch(actions.errorFetchUser())
  }
}

export const updateLandingPageInfoAction = (leadPageInfo: LeadSourceInfo): AppThunk => async (
  dispatch: AppDispatch
) => {
  try {
    dispatch(actions.updateLandingPageInfo(leadPageInfo))
  } catch (error) {
    console.error(error.message)
  }
}
